import * as v from "valibot";

import { rpcContract } from "../rpc";

export const deletePostRpcContract = rpcContract({
  name: "deletePost",
  paramsSchema: v.object({
    postId: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type DeletePostParams = v.InferOutput<(typeof deletePostRpcContract)["paramsSchema"]>;
export type DeletePostResult = v.InferOutput<(typeof deletePostRpcContract)["resultSchema"]>;
